import { Component, DoCheck, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { UserService } from '../../../service/user/user.service';
import { CommonService } from '../../../service/common/common.service';
import { RoleService } from '../../../service/role/role.service';
import { OwnerService } from 'app/service/owner/owner.service';
import { LogicalwhService } from '../../../service/logicalwh/logicalwh.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';

@Component({
  selector: 'wa9003',
  templateUrl: 'wa9003.component.html',
  styleUrls: ['wa9003.component.scss']
})
export class Wa9003Component implements DoCheck, OnChanges {
  public componentTitle = 'WA9003:ユーザマスタ更新';

  public logicalWhs: any;
  public roles: any;
  public owners: any;

  private userId: string;
  public userCd: string;
  public userTx: FormControl;
  public langTx = 'ja';
  public passwordTx2: FormControl;
  public roleId: FormControl;
  public linkedOwnerId: FormControl;
  public logicalWhId: FormControl;

  public validation = validation;

  public working = true;
  public working2 = false;
  public height = 500;
  public production = environment.production;
  public backgroundColor: string;

  public ownerActive = 'disabled';
  public isDisabledOnLinkedOwnerId = false ;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  public userTxCls = '';
  public passwordTx2Cls = '';
  public logicalWhIdCls = '';
  public roleIdCls = '';
  public linkedOwnerIdCls = '';

  private isSubmitButtonEnabled = false;

  private errorInfo = '';

  private item = null;
  @Input() isShow = false;
  @Output() onSubmitClick = new EventEmitter();
  @Input() userInput: object = [];
  private openwindow: boolean = false;
  private isDelayHide = true;
  
  constructor(private userService: UserService, private logicalwhService: LogicalwhService, private roleService: RoleService, private ownerService: OwnerService, private commonService: CommonService) {
    this.userId = sessionStorage.getItem('useredit');

    // ユーザ名
    this.userTx = new FormControl(this.userTx, [
      Validators.required,
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.minLength(validation.userTx.minLength),
      Validators.maxLength(validation.userTx.maxLength)
    ]);

    this.passwordTx2 = new FormControl(this.passwordTx2, [Validators.required, Validators.pattern(validation.password)]);
    this.logicalWhId = new FormControl(this.logicalWhId, [Validators.required]);
    this.roleId = new FormControl(this.roleId, [Validators.required]);
    this.linkedOwnerId = new FormControl(this.linkedOwnerId);
    sessionStorage.removeItem('wa9003openWindow');
  }

  onResize(event) {
    this.height = event.target.innerHeight - 80;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // TODO should be execute parallel, but API server don't work properly
    // DONE.
    this.logicalwhService
      .get()
      .then(outputJson => {
        this.logicalWhs = outputJson.logicalWhs;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.roleService
      .get()
      .then(_outputJson => {
        this.roles = _outputJson.roles;

      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.ownerService
      .get()
      .then(_outputJson => {
        console.log(JSON.stringify(_outputJson));
        this.owners = _outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onSubmit() {
    let errors = false;
    if (this.userTx.errors !== null) {
      this.userTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    if (this.logicalWhId === undefined) {
      this.errorInfo = '論理倉庫を選択してください';
      return;
    }
    if (this.roleId === undefined) {
      this.errorInfo = '権限を選択してください';
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;

    let logicalWhId = this.logicalWhIdCls === this.STRINGS_ACTIVE ? this.logicalWhId.value.trim() : this.userInput['logicalWhId'];
    let roleId = this.roleIdCls === this.STRINGS_ACTIVE ? this.roleId.value : this.userInput['roleId'];
    let linkedOwnerId = this.linkedOwnerIdCls === this.STRINGS_ACTIVE ? this.linkedOwnerId.value : this.userInput['linkedOwnerId'];
      this.userService
    
      .put(this.userId, this.userTx.value.trim(), this.langTx, undefined, roleId, linkedOwnerId, logicalWhId)
      .then(outputJson => {
        sessionStorage.removeItem('wa9003openWindow');
        this.onSubmitClick.emit();
        this.working = false;
        this.working2 = false;
        this.cancel();
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working = false;
        this.working2 = false;
      });
  }

  initDatas() {
    if (this.userInput[0] !== null) {
      const user: object = this.userInput;
      this.userId = user['userId'];
      // ユーザーコード
      this.userCd = user['userCd'];
      // ユーザ名
      this.userTx.setValue(user['userTx']);
      // 論理倉庫
      this.logicalWhId.setValue(user['logicalWhId']);
      // 権限
      this.roleId.setValue(user['roleId']);

      this.linkedOwnerId.setValue(user['linkedOwnerId']);
      
        if (this.roleId.value == 3) {
          this.ownerActive = 'active';
          this.isDisabledOnLinkedOwnerId = false;
        } else {
          this.ownerActive = 'disabled'
        this.isDisabledOnLinkedOwnerId = true;
        this.linkedOwnerId.setValue (null);
        }



      
      //
      console.log('passsword====' + user['passwordTx'], user);
      this.passwordTx2.setValue(user['passwordTx']);
    }
  }

  ngDoCheck() {
    if (!this.isShow) return;

    this.userTxCls = this.userTx.value === this.userInput['userTx'] ? '' : this.userTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.passwordTx2Cls = this.passwordTx2.value === this.userInput['passwordTx2'] ? '' : this.passwordTx2.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.logicalWhIdCls = this.logicalWhId.value === this.userInput['logicalWhId'] ? '' : this.logicalWhId.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.roleIdCls = this.roleId.value === this.userInput['roleId'] ? '' : this.roleId.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.linkedOwnerIdCls = this.linkedOwnerId.value === this.userInput['linkedOwnerId'] ? '' : 
      (this.linkedOwnerId.errors == null && (this.roleId.value != 3 || this.linkedOwnerId.value != null)) ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    if (
      this.userTxCls !== this.STRINGS_ERROR &&
      this.passwordTx2Cls !== this.STRINGS_ERROR &&
      this.logicalWhIdCls !== this.STRINGS_ERROR &&
      this.roleIdCls !== this.STRINGS_ERROR &&
      this.linkedOwnerIdCls !== this.STRINGS_ERROR
    ) {
      this.isSubmitButtonEnabled =
        this.userTxCls === this.STRINGS_ACTIVE ||
        this.passwordTx2Cls === this.STRINGS_ACTIVE ||
        this.logicalWhIdCls === this.STRINGS_ACTIVE ||
        this.roleIdCls === this.STRINGS_ACTIVE ||
        this.linkedOwnerIdCls === this.STRINGS_ACTIVE 
      } else {
      this.isSubmitButtonEnabled = false;
    }
  }

  cancel() {
    this.onSubmitClick.emit();
    this.working = false;
    // this.ngOnChanges();

    this.openwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
    this.errorInfo = '';
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  ownerChange(){
    if (this.roleId.value == 3) {
      this.ownerActive = 'active';
      this.isDisabledOnLinkedOwnerId = false;
    } else {
      this.ownerActive = 'disabled';
      this.isDisabledOnLinkedOwnerId = true;
      this.linkedOwnerId.setValue (null);
    }
}

  changes(event) {
    this.errorInfo = '';
    if (!this.userTx.errors && !this.passwordTx2.errors) {
      if (this.userInput['userTx'] !== this.userTx || this.userInput['roleId'] !== this.roleId || this.userInput['logicalWhId'] !== this.logicalWhId || this.passwordTx2) {
        this.working = true;
      } else {
        this.working = false;
      }
    } else {
      this.working = false;
    }

    if (event.target.value === '') {
      this.working = false;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9003/wa9003.component.ts